module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18521/js/img/valuePropModals/FormConditionalLogic/ValueProp1.svg"